
import React from 'react';
import { Route, RouteProps } from 'react-router';
import utc from 'dayjs/plugin/utc'

import dayjs, { Dayjs } from "dayjs";

import { integer } from 'aws-sdk/clients/cloudfront';

export function validateEmail(email: string): boolean {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export function covertDateTimeField(date: Date | string): string {
  if (dayjs(date).isValid()) {
    return dayjs(date).format("DD - MMM h:mm A");
  }
  return date as string;
}

export function getDateDifference(date: Date): integer {
  return dayjs(date).diff(dayjs(), 'day');
}

export function formatDateTime(date: Date | string, format?: string) {
  if (date) {
    return dayjs(date).format(format || "MMM DD, YYYY hh:mm:ss A");
  }

  return date;
}


export function formatDate(date: Date | string, format?: string) {
  if (date) {
    return dayjs(date).format(format || "YYYY-MM-DD");
  }

  return date;
}

export function timeAgo(dateString: string): string {
  const givenDate = new Date(dateString);
  var _date = new Date(dateString);

  // var newDate = new Date(dateString);

  // const now = new Date();
  var _now = new Date();

  givenDate.setMinutes(_date.getMinutes() - _date.getTimezoneOffset());

  // now.setMinutes(_now.getMinutes() - _now.getTimezoneOffset());


  const now = new Date();
  const diff = now.getTime() - givenDate.getTime();

  const minutes = Math.floor(diff / (1000 * 60));
  if (minutes < 60) {
    return `${minutes} minutes ago`;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours < 24) {
    return `${hours} hours and ${remainingMinutes} minutes ago`;
  }

  const days = Math.floor(hours / 24);
  const remainingHours = hours % 24;
  if (days < 7) {
    return `${days} days and ${remainingHours} hours ago`;
  }

  const weeks = Math.floor(days / 7);
  const remainingDays = days % 7;
  if (weeks < 4) {
    return `${weeks} weeks and ${remainingDays} days ago`;
  }

  const months = Math.floor(weeks / 4);
  const remainingWeeks = weeks % 4;
  if (months < 12) {
    return `${months} months and ${remainingWeeks} weeks ago`;
  }

  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;
  return `${years} years and ${remainingMonths} months ago`;
}

export function convertUTCDateToLocalDate(date: Date | string) {
  try {
    if (date) {
      var _date = new Date(date);
      var newDate = new Date(date);

      newDate.setMinutes(_date.getMinutes() - _date.getTimezoneOffset());
      return dayjs(newDate).format("DD - MMM -YYYY hh:mm a");
    }
    return date;
  } catch (err) {
    return [] as any;
  }
}
export function convertDateToUTC(date: Date | string): string {
  try {
    if (date) {
      const _date = new Date(date);
      const utcDate = new Date(
        Date.UTC(
          _date.getFullYear(),
          _date.getMonth(),
          _date.getDate(),
          _date.getHours(),
          _date.getMinutes(),
          _date.getSeconds(),
          _date.getMilliseconds()
        )
      );
      return utcDate.toISOString(); // Returns the date in UTC ISO 8601 format
    }
    return "";
  } catch (err) {
    console.error("Error converting date to UTC:", err);
    return "";
  }
}


export function convertFormDateToUTC(localDateTime: string): string {
  const localDate = new Date(localDateTime);
  const utcDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000);
  return utcDate.toISOString().slice(0, 16);
};


export function convertToUtc(date: any) {
  try {
    if (date) {
      dayjs.extend(utc)
      var d = new Date(date)
      var day = dayjs(d).utc().format();

      // dayjs.utc().format()


      // var _date = new Date(date);
      // var newDate = new Date(date);

      // newDate.setMinutes(_date.getMinutes() - _date.getTimezoneOffset());
      return day;
    }
    return date;
  } catch (err) {
    return "Error" as any;
  }
}


export function convertUTCDateToLocalDateChart(date: Date | string) {
  try {
    if (date) {
      var _date = new Date(date);
      var newDate = new Date(date);
      newDate.setMinutes(_date.getMinutes() - _date.getTimezoneOffset());

      return dayjs(newDate).format("DD - MMM hh:mm:ss a");
    }
    return date;
  } catch (err) {
    return [] as any;
  }
}

export function convertDateToUTCWithStartTime(dateString: string): string {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
  return date.toISOString();
}

export function convertDateToUTCWithEndTime(dateString: string): string {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day, 23, 59, 0));
  return date.toISOString();
}


export function convertPeriodToFromAndTo(period: string) {
  try {
    if (period) {
      dayjs.extend(utc);

      const utcNow = dayjs.utc().format();

      if (period === 'LastHour') {
        const lastHour = dayjs.utc().subtract(1, 'hour').format();
        return { 'from': lastHour, 'to': utcNow };
      }
      else if (period === 'Today') {
        // Start of today in UTC
        const startOfDay = dayjs.utc().startOf('day').format();
        return { 'from': startOfDay, 'to': utcNow };
      }
      else if (period === 'ThisWeek') {
        // Start of this week (Monday) in UTC
        const weekFirstDay = dayjs.utc().startOf('week').format();
        return { 'from': weekFirstDay, 'to': utcNow };
      }
      else if (period === 'Last7Days') {
        // 7 days ago from now
        const lastSevenDays = dayjs.utc().subtract(7, 'day').format();
        return { 'from': lastSevenDays, 'to': utcNow };
      }
      else if (period === 'Last30Days') {
        // 30 days ago from now
        const lastThirtyDays = dayjs.utc().subtract(30, 'day').format();
        return { 'from': lastThirtyDays, 'to': utcNow };
      }
      else if (period === 'ThisMonth') {
        // Start of this month in UTC
        const startOfMonth = dayjs.utc().startOf('month').format();
        return { 'from': startOfMonth, 'to': utcNow };
      }
      else if (period === 'LastMonth') {
        // Start and end of last month in UTC
        const startOfLastMonth = dayjs.utc().subtract(1, 'month').startOf('month').format();
        const endOfLastMonth = dayjs.utc().subtract(1, 'month').endOf('month').format();
        return { 'from': startOfLastMonth, 'to': endOfLastMonth };
      }
      else if (period === 'ThisYear') {
        // Start of this year in UTC
        const startOfYear = dayjs.utc().startOf('year').format();
        return { 'from': startOfYear, 'to': utcNow };
      }
    }
    return period;
  } catch (err) {
    console.error('Error in convertPeriodToFromAndTo:', err);
    return [];
  }
}

export function convertHoursToHoursAndMinutes(decimalHours) {
  if (!decimalHours || decimalHours === 0) {
    return "0 H 0 Min";
  }
  
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);
  
  // Handle case where rounding minutes gives us 60
  if (minutes === 60) {
    return `${hours + 1} H 0 Min`;
  }
  
  if (hours === 0) {
    return `${minutes} Min`;
  } else if (minutes === 0) {
    return `${hours} H`;
  } else {
    return `${hours} H ${minutes} Min`;
  }
}

export function convertBreakdownPeriodToFromAndTo(period: string, year: string) {
  try {
    if (period) {
      dayjs.extend(utc)

      var utcNow = dayjs.utc().format();
      var currHour = dayjs.utc().get('hour');
      var currDay = dayjs().get('day');


      if (period == 'LastSixMonth') {
        var slm = new Date(dayjs().year(), (dayjs().month() - 6), 1, 0, 0, 0);
        var startOfLastMonth = dayjs(slm).utc().format();

        var locatTime = new Date(dayjs().year(), dayjs().month(), 1, 0, 0, 0);
        locatTime.setMinutes(locatTime.getMinutes() - 1)
        var elm = dayjs(locatTime).utc();
        var endOfLastMonth = elm.format();

        return ({ 'from': startOfLastMonth, 'to': endOfLastMonth })

      }
      else if (period == 'FirstSixMonth') {
        var slm = new Date(dayjs().year(), (dayjs().month() + 6), 1, 0, 0, 0);
        var startOfLastMonth = dayjs(slm).utc().format();

        var locatTime = new Date(dayjs().year(), dayjs().month(), 1, 0, 0, 0);
        locatTime.setMinutes(locatTime.getMinutes() - 1)
        var elm = dayjs(locatTime).utc();
        var endOfLastMonth = elm.format();

        return ({ 'from': startOfLastMonth, 'to': endOfLastMonth })

      }
      else if (period == 'ThisYear') {
        var firstMonth = dayjs().month(0).format();
        var currYear = dayjs().get('year');
        var currYears = dayjs().year(currYear).format();

        return ({ 'from': firstMonth, 'to': currYears })
      }
    }
    return period;
  } catch (err) {
    return [] as any;
  }
}



export function convertUTCDateToLocalDateLineChart(date: Date | string, category: any) {
  try {
    if (date) {
      var _date = new Date(date);
      var newDate = new Date(date);
      newDate.setMinutes(_date.getMinutes() - _date.getTimezoneOffset());
      if (category == 'Today') {
        return dayjs(newDate).format("hh:mm a");
      } else if (category == 'LastHour') {
        return dayjs(newDate).format("hh:mm a");
      } else {
        return dayjs(newDate).format("DD - MMM\nhh:mm a");
      }
    }
    return date;
  } catch (err) {
    return [] as any;
  }
}

export function convertStringToJson<T>(strValue: string): T {
  try {
    return JSON.parse(strValue);
  } catch (err) {
    return [] as any;
  }
}

interface AppRouteProps extends RouteProps {
  component: any
  props?: any;
}



export function capitalizeFirstLetters(sentence) {
  // Split the sentence into words
  const words = sentence.split(' ');

  // Capitalize the first letter of each word
  const capitalizedWords = words.map(word => {
    // Handle empty words
    if (word.length === 0) return word;

    // Capitalize the first letter and keep the rest of the word as is
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  // Join the words back into a sentence
  return capitalizedWords.join(' ');
}

export const AppRoute = (props: AppRouteProps) => (
  <Route
    {...props}
    render={(renderProps) => {
      return (
        <>
          <props.component {...renderProps}{...props.props} />
        </>
      )
    }
    } />
);

export const validEmail = (email: string) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email) ? undefined : "invalid email";
}